import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import "firebase/compat/performance";
import { enableIndexedDbPersistence } from "firebase/firestore";

const config = {
    apiKey: "AIzaSyBUX7OAUV3wIGK0-SviGWsMakZY_zP_66A",
    authDomain: "digitalna-kartica.firebaseapp.com",
    databaseURL: "https://digitalna-kartica.firebaseio.com",
    projectId: "digitalna-kartica",
    storageBucket: "digitalna-kartica.appspot.com",
    messagingSenderId: "127038985299",
    appId: "1:127038985299:web:16fb8d3a670c5fdacaa2a6",
    measurementId: "G-469VBJT0WB"
};

class Firebase {
    constructor() {
        firebase.initializeApp(config);

        this.auth = firebase.auth();
        this.db = firebase.firestore();
        this.db.settings({
            cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
        });

        this.storage = firebase.storage();
        this.publicStorage = firebase.app().storage("gs://digitalna-kartica-public");
        this.perf = firebase.performance();
    }

    // Firestore api
    geoPoint = (lat, long) => new firebase.firestore.GeoPoint(lat, long);

    visits = (companyUid, lastVisible = null) => {
        if(lastVisible === null) {
            return this.db.collection("company").doc(companyUid)
                .collection("visits")
                .orderBy('lastVisit', 'desc')
                .limit(1000);
        } else {
            return this.db.collection("company").doc(companyUid)
                .collection("visits")
                .orderBy('lastVisit', 'desc')
                .startAfter(lastVisible)
                .limit(5000);
        }
    }

    visitsMoreThan6 = companyUid => this.db.collection("company").doc(companyUid)
        .collection("visits").where('count', '>', 6)
        .orderBy('count')
        .orderBy('lastVisit', 'desc');


    scans = companyUid => this.db.collection("company").doc(companyUid)
        .collection("scan").orderBy('time', 'desc')

    scansMoreThan2RSD = (companyUid) => this.db.collection("company").doc(companyUid)
        .collection("scan")
        .where('value', '<', 2)

    scansTimeOrder = companyUid => this.db.collection("company").doc(companyUid)
        .collection("scan").orderBy('time')

    bonusEventTimeOrder = companyUid => this.db.collection("company").doc(companyUid)
        .collection("bonusEvent").orderBy('time', 'desc')

    bonusEventHistoryTimeOrder = companyUid => this.db.collection("company").doc(companyUid)
        .collection("bonusEventHistory").orderBy('time', 'desc')

    campaigns = companyUid => this.db.collection("company").doc(companyUid)
        .collection("campaign").orderBy('time', 'desc');

    campaignsBulk = companyUid => this.db.collection("company").doc(companyUid)
        .collection("campaign")
        .where('numberOfUserToTarget', '>', 1);

    usersThatSeenCampaign = (companyUid, campaignId) => this.db.collection("company").doc(companyUid)
        .collection("campaign").doc(campaignId).collection("seen").orderBy('time');

    usersThatUsedCampaign = (companyUid, campaignId) => this.db.collection("company").doc(companyUid)
        .collection("campaign").doc(campaignId).collection("usersThatUsed");

    usersNotificationForCampaign = (uid, campaignId) => this.db.collection("users").doc(uid)
        .collection("notification").where("campaignId", "==", campaignId).orderBy('time');

    company = companyUid => this.db.collection("company").doc(companyUid);
    activeCompanies = () => this.db.collection("company")
        .where("active", "==", true);
    petShopCompanies = () => this.db.collection("company")
        .where("billOptionsType", "==", "petShop");

    storeBonusEvent = (companyUid, data) => this.db.collection("company").doc(companyUid)
        .collection("bonusEventHistory").add(data)
    getBonusEvent = (companyUid) => this.db.collection("company").doc(companyUid)
        .collection("bonusEventHistory")

    email = () => this.db.collection("email");

    devices = companyUid => this.db.collection("company").doc(companyUid)
        .collection("pos").orderBy('created', 'desc')

    deviceUpdate = (companyUid, guid) => this.db.collection("company").doc(companyUid)
        .collection("pos").doc(guid)

    stores = () => this.db.collection("stores");
    storesForUid = (companyUid) => this.db.collection("stores")
        .where("companyUid", "==", companyUid);

    predictionsForUid = (companyUid) => this.db.collection("company")
        .doc(companyUid)
        .collection("predictions")

    // AI Advisor methods
    aiSuggestions = (companyUid) => this.db.collection("company")
        .doc(companyUid)
        .collection("aiSuggestions")
        .orderBy('createdAt', 'desc')

    aiSuggestion = (companyUid, suggestionId) => this.db.collection("company")
        .doc(companyUid)
        .collection("aiSuggestions")
        .doc(suggestionId)

    aiSettings = (companyUid, settingId) => this.db.collection("company")
        .doc(companyUid)
        .collection("aiSettings")
        .doc(settingId)

    aiAutomationRules = (companyUid) => this.db.collection("company")
        .doc(companyUid)
        .collection("aiAutomationRules")

    aiAutomationRule = (companyUid, ruleId) => this.db.collection("company")
        .doc(companyUid)
        .collection("aiAutomationRules")
        .doc(ruleId)

    addBonusEvent = (companyUid) => this.db.collection("company").doc(companyUid)
        .collection("bonusEvent")

    logs = () => this.db.collection("logs")
        .orderBy('time', 'desc')
        .limit(1000)

    storeProfile = (companyUid) => this.db.collection("companyProfile").doc(companyUid)
    storeProfileLinks = (companyUid) => this.db.collection("companyProfile").doc(companyUid)
        .collection("links")
        .orderBy('order', 'asc')

    storeProfileLinksCreate = (companyUid) => this.db.collection("companyProfile")
        .doc(companyUid)
        .collection("links")
    storeProfileLinksUpdate = (companyUid, id) => this.db.collection("companyProfile").doc(companyUid)
        .collection("links").doc(id)

    storeProfileNews = (companyUid) => this.db.collection("companyProfile").doc(companyUid)
        .collection("news")
        .orderBy('order', 'asc')

    storeProfileNewsCreate = (companyUid) => this.db.collection("companyProfile")
        .doc(companyUid)
        .collection("news")
    storeProfileNewsUpdate = (companyUid, id) => this.db.collection("companyProfile").doc(companyUid)
        .collection("news").doc(id)

    storeLocation = (companyUid) => this.db.collection("stores")
        .where("companyUid", "==", companyUid)
        .orderBy('order', 'asc');

    storeLocationCreate = (companyUid) => this.db.collection("stores")
    storeLocationUpdate = (companyUid, id) => this.db.collection("stores").doc(id)

    // Auth api
    doCreateUserWithEmailAndPassword = (email, password) =>
        this.auth.createUserWithEmailAndPassword(email, password);

    doSignInWithEmailAndPassword = (email, password) =>
        this.auth.signInWithEmailAndPassword(email, password);

    doSignOut = () => {
        localStorage.setItem('localStoragePin', '');
        this.auth.signOut();
    };

    recaptchaVerifier = (buttonId) => new firebase.auth.RecaptchaVerifier(buttonId, {
        'size': 'invisible',
        'callback': () => {
            console.log("RECAPTCA")
        },
    });

    phoneMultiFactorGenerator = () => firebase.auth.PhoneMultiFactorGenerator.FACTOR_ID

    verifyEmail = () => firebase.auth().currentUser.sendEmailVerification()

    doSignInWithSMS = (phoneInfoOptions, verifier, resolver) => {
        const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
        return phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, verifier)
    }

    doEnterPhoneSMSCode = (verificationId, verificationCode, resolver) => {
        const cred = firebase.auth.PhoneAuthProvider.credential(
            verificationId, verificationCode);
        const multiFactorAssertion =
            firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
        return resolver.resolveSignIn(multiFactorAssertion)
    }

    doRegisterForMultiFactorAuth = (phoneNumber, recaptchaVerifier) =>
        this.auth.currentUser.multiFactor.getSession().then(function (multiFactorSession) {
            const phoneInfoOptions = {
                phoneNumber: phoneNumber,
                session: multiFactorSession
            };
            const phoneAuthProvider = new firebase.auth.PhoneAuthProvider();
            return phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
        });

    doEnrollUserForMultiFactor = (verificationId, verificationCode) => {
        const cred = firebase.auth.PhoneAuthProvider.credential(verificationId, verificationCode);
        const multiFactorAssertion = firebase.auth.PhoneMultiFactorGenerator.assertion(cred);
        return this.auth.currentUser.multiFactor.enroll(multiFactorAssertion, 'My personal phone number');
    }

    doPasswordReset = email => this.auth.sendPasswordResetEmail(email);

    doPasswordUpdate = password =>
        this.auth.currentUser.updatePassword(password);

    currentUserAuth = () => this.auth.currentUser;

    // firebase Storage
    storageReference = (storagePath) => this.storage.ref(storagePath);

    publicStorageReference = (storagePath) => this.publicStorage.ref(storagePath);

    fireBaseTimestamp = (date) => firebase.firestore.Timestamp.fromDate(date).toDate();
}

export default Firebase;
